import { render, staticRenderFns } from "./SignUpPageBase.vue?vue&type=template&id=1cf30ec8&"
import script from "./SignUpPageBase.vue?vue&type=script&lang=js&"
export * from "./SignUpPageBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports